// extracted by mini-css-extract-plugin
module.exports = {"loading":"InformationTable_loading__1QccJ","table":"InformationTable_table__2d9gY"};